module.exports = __webpack_public_path__ + "img/md-call.78bc29b2.svg";